exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-099ba681]{text-align:center;font-size:25px;background:rgba(0,0,0,.06);border-bottom:1px solid #000}.body[data-v-099ba681]{line-height:50px;font-size:20px;overflow:hidden}.body-title[data-v-099ba681]{width:125px;float:left;height:40px}.body-content[data-v-099ba681]{display:inline-block}[data-v-099ba681] .ivu-modal-body{padding-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-099ba681","scoped":true,"sourceMap":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/gcpManage/parts/patientInfo.vue
// module id = zTYf
// module chunks = 0